import { render, staticRenderFns } from "./InfoPix.vue?vue&type=template&id=570b08ce&scoped=true"
import script from "./InfoPix.vue?vue&type=script&lang=js"
export * from "./InfoPix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570b08ce",
  null
  
)

export default component.exports